import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MailCreationRightDto, MailRightsDto } from '../interfaces';
import { MeRightMail } from 'src/app/shared/models/iCourrier/me/right-mail-id';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailsRightsService {
  private url: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.url = config.apiICourrierBaseUrl;
  }

  public fetchGlobalMailRights(): Observable<MailRightsDto> {
    return this.http.get<MailRightsDto>(`${this.url}/Me/Rights/Mails`);
  }

  public fetchMailCreationRights(): Observable<MailCreationRightDto[]> {
    return this.http.get<MailCreationRightDto[]>(`${this.url}/Me/Rights/MailsCreation`);
  }

  public getRightsMailByID(id: number): Observable<MeRightMail> {
    return this.http.get<MeRightMail>(`${this.url}/Me/Rights/Mails/${id}`);
  }
}
